var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCups2Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23.25L5.2148 20.7857L11.3418 17.5L11.6871 14.2143L1.89947 5.17857L2.24481 1.89286H7.2005L7.37318 0.25H14.8067H22.2403L22.0676 1.89286H27.0233L26.6779 5.17857L14.9909 14.2143L14.6456 17.5L20.0819 20.7857L19.8229 23.25H12.3893H4.95579ZM7.85378 3.53571H4.54999L4.46365 4.35714L7.50844 6.82143L7.85378 3.53571ZM21.069 3.53571H24.3728L24.2864 4.35714L20.7236 6.82143L21.069 3.53571Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0294 2.01416L15.311 2.01416L14.3111 11.5623L12.7056 11.5623L13.4661 4.30967H13.452L12.1987 5.49263H12.1846L12.3676 3.74635L14.0294 2.01416Z",
    fill: "#161C31"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7748_110745",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 32,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9292 23.25H45.5955V0.25H24.422L24.2493 1.89286H29.205L28.8597 5.17857L17.1727 14.2143L16.8273 17.5L22.2636 20.7857L22.0046 23.25L14.9292 23.25Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7748_110745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2378 23.25L23.4968 20.7857L29.6238 17.5L29.9691 14.2143L20.1815 5.17857L20.5268 1.89286H25.4825L25.6552 0.25H33.0887H40.5222L40.3496 1.89286H45.3053L44.9599 5.17857L33.2729 14.2143L32.9276 17.5L38.3639 20.7857L38.1049 23.25H30.6713H23.2378ZM26.1358 3.53571H22.832L22.7456 4.35714L25.7904 6.82143L26.1358 3.53571ZM39.351 3.53571H42.6547L42.5684 4.35714L39.0056 6.82143L39.351 3.53571Z",
    fill: "#D9D7CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7097 11.5622L29.8928 9.80186C30.0055 8.74564 30.3857 8.26682 31.3433 7.30919L32.315 6.35155C32.8643 5.80232 33.0192 5.4925 33.0896 4.70386L33.1741 3.91522C33.2304 3.3519 32.9347 3.19699 32.6108 3.19699C32.2728 3.19699 31.9911 3.3519 31.9348 3.90114L31.8081 5.14043L30.3434 5.14043L30.4843 3.80256C30.611 2.56326 31.3574 1.90137 32.7094 1.90137C34.2444 1.90137 34.8922 2.64776 34.7373 4.05605L34.6387 4.98552C34.5261 5.9854 34.2866 6.40789 33.3713 7.32327L32.2587 8.40765C31.8081 8.85831 31.4842 9.18221 31.4137 9.85819L31.3715 10.2525L34.0191 10.2525L33.8782 11.5622L29.7097 11.5622Z",
    fill: "#161C31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCups2Updated);
export default __webpack_public_path__ + "static/media/cups-2-updated.e8036f5089c5605457f0cdbff6186579.svg";
export { ForwardRef as ReactComponent };